export default {
  "Moira": {
    name: '',
    'type': 'Support'
  },
  "McCree": {
    name: '',
    'type': 'Offensif'
  },
  "Ana": {
    name: '',
    'type': 'Support'
  },
  "Zenyatta": {
    name: '',
    'type': 'Support'
  },
  "Orisa": {
    name: '',
    'type': 'Tank'
  },
  "Tracer": {
    name: '',
    'type': 'Offensif'
  },
  "Pharah": {
    name: '',
    'type': 'Offensif'
  },
  "Soldier: 76": {
    name: '',
    'type': 'Offensif'
  },
  "Reaper": {
    name: '',
    'type': 'Offensif'
  },
  "Mercy": {
    name: '',
    'type': 'Support'
  },
  "Hanzo": {
    name: '',
    'type': 'Défensif'
  },
  "Torbjörn": {
    name: '',
    'type': 'Défensif'
  },

  "Reinhardt": {
    name: '',
    'type': 'Tank'
  },

  "Winston": {
    name: '',
    'type': 'Tank'
  },

  "Widowmaker": {
    name: '',
    'type': 'Défensif'
  },

  "Bastion": {
    name: '',
    'type': 'Défensif'
  },

  "Symmetra": {
    name: '',
    'type': 'Support'
  },
  "Genji": {
    name: '',
    'type': 'Offensif'
  },
  "Roadhog": {
    name: '',
    'type': 'Tank'
  },
  "Junkrat": {
    name: '',
    'type': 'Défensif'
  },
  "Zarya": {
    name: '',
    'type': 'Tank'
  },
  "Lúcio": {
    name: '',
    'type': 'Support'
  },
  "D.Va": {
    name: '',
    'type': 'Tank'
  },
  "Mei": {
    name: '',
    'type': 'Défensif'
  },
  "Sombra": {
    name: '',
    'type': 'Défensif'
  },
  "Doomfist": {
    name: '',
    'type': 'Offensif'
  }
}



// WEBPACK FOOTER //
// ./src/data/heroclassification.js